import styled from "styled-components";
import {Field, Filter, PrimitiveObject, RefCondition, TableI} from "../../../Types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAnglesRight, faMagnifyingGlassPlus, faTrash} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import {selectActiveTable} from "../../../features/projectSlice";
import {FilterRep} from "./SearchRefEntry";
import {faObjectGroup} from "@fortawesome/free-regular-svg-icons";
import {
    deleteAllFilters,
    fetchTableByQuery,
    mergeTableFilters,
    setActiveTable,
    setTableFilters
} from "../../../features/tableSlice";
import {refConditionToFilters} from "./RefValueUI";
import {nanoid} from "@reduxjs/toolkit";

interface PropsI {
    currentTable: string,
    table: string,
    condition: RefCondition[],
    currentSchema: TableI,
    schema: TableI,
    record: PrimitiveObject,
    closeSearch: () => void,
}

export default function SearchRefExtended({currentTable, table, condition, schema, closeSearch, record}: PropsI) {

    const dispatch = useAppDispatch();

    const allFilters = useAppSelector(state => state.tables.queries[table].current.filters);
    const filters = allFilters.filter(f => f.locked)
    const fields = Object.fromEntries(schema.fields.map(f => ([f.key, f])))

    const mergeAndSearch = () => {
        merge()
        dispatch(setActiveTable(table))
        dispatch(fetchTableByQuery({clean: true, pageIndex: 1}))
        closeSearch()
    };

    const merge = () => dispatch(mergeTableFilters({
        table: table,
        filters: refConditionToFilters(condition, record).map(f => ({
            ...f,
            nanoid: nanoid(),
            locked: true,
            type: fields[f.field].type
        }))
    }));

    return <Container>
        <div className="search-ref-ext-buttons">
            <button className={"btn-cmn"} onClick={mergeAndSearch}>
                <FontAwesomeIcon icon={faMagnifyingGlassPlus} className={'fa-secondary-color-text'}
                                 title={"Злити фільтри та шукати"}
                                 style={{width: "1.2rem", height: "1.2rem"}}/>
            </button>
            <button className={"btn-cmn"}
                    onClick={merge}>
                <FontAwesomeIcon icon={faObjectGroup} className={'fa-secondary-color-text'}
                                 title={"Злити фільтри"}
                                 style={{width: "1.2rem", height: "1.2rem"}}/>
            </button>
            <button className={"btn-cmn"} onClick={() => dispatch(deleteAllFilters(table))}>
                <FontAwesomeIcon icon={faTrash} className={'fa-secondary-color-text'}
                                 title={"Очистити"}
                                 style={{width: "1.2rem", height: "1.2rem"}}/>
            </button>
        </div>
        <div className="search-ref-ext-current-filters">
            {filters.map((f, i) => <FilterRep f={f as Filter} field={fields[f.field!]} key={i}/>)}
            {filters.length === 0 && <div className="empty">Фільтри відсутні</div>}
        </div>
    </Container>
}

const Container = styled.div`
    display: flex;
    flex-flow: column;
    gap: .5rem;

    background-color: var(--table-row-odd-bg-color);
    padding: .2rem;
    //border-radius: .2rem;
    min-width: 200px;
    max-width: 300px;
    width: 100%;

    & .search-ref-ext-buttons {
        display: flex;
        gap: .5rem;
        justify-content: center;
    }
    
    & .empty {
        height: 60px;
        align-items: center;
        display: flex;
        justify-content: center;
    }

`
